import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/theme-command.css";
import "@/theme-mobile.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
